export interface SignedUpload {
  uploadUrl: string

  requiredHeaders?: Record<string, string | number> | null | undefined
}

export interface PutBytesOptions {
  onProgress?: (fraction: number) => void
  signal?: AbortSignal
}

export function putBytesToSignedUrl(
  upload: SignedUpload,
  body: Blob,
  options: PutBytesOptions = {},
): Promise<void> {
  const { onProgress, signal } = options

  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest()
    request.open('PUT', upload.uploadUrl, true)

    const contentType = upload.requiredHeaders?.['Content-Type']
    if (typeof contentType === 'string' && contentType !== '') {
      request.setRequestHeader('Content-Type', contentType)
    }

    if (onProgress) {
      request.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && event.total > 0) {
          onProgress(event.loaded / event.total)
        }
      })
    }

    request.addEventListener('load', () => {
      if (request.status >= 200 && request.status < 300) {
        resolve()
        return
      }
      reject(
        new Error(
          request.status === 403
            ? 'Storage rejected the upload. The signed URL may have expired, or the file changed after it was chosen — try again.'
            : `Storage rejected the upload (HTTP ${String(request.status)}).`,
        ),
      )
    })

    request.addEventListener('error', () => {
      reject(new Error('Could not reach storage to upload the file.'))
    })
    request.addEventListener('abort', () => {
      reject(new Error('Upload cancelled.'))
    })

    signal?.addEventListener('abort', () => {
      request.abort()
    })

    request.send(body)
  })
}
